import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const AUTH_MODES = [
    { label: 'OTP', value: 'OTP' },
    { label: 'Aadhaar XML', value: 'AADHAAR_XML' },
    { label: 'Biometric', value: 'BIOMETRIC' },
];
const SIGN_TYPES = [
    { label: 'Digital', value: 'DIGITAL' },
    { label: 'Electronic', value: 'ELECTRONIC' },
];

const EsignInitializeSuresignInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-pencil', title: 'E-Sign Initialize (Suresign)', subtitle: 'Start a new Suresign-backed e-sign session' }}
        fields={[
            { name: 'full_name', label: 'Full Name', icon: 'pi-user', placeholder: 'Enter full name', maxLength: 100, autoCapitalize: 'words' },
            { name: 'mobile_number', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
            { name: 'user_email', label: 'Email', icon: 'pi-envelope', placeholder: 'user@example.com', maxLength: 100, htmlType: 'email', inputMode: 'email', autoCapitalize: 'none', spellCheck: false,
              regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, regexError: 'Enter a valid email' },
            { name: 'auth_mode', label: 'Auth Mode', type: 'dropdown', options: AUTH_MODES, default: 'OTP', colClass: 'col-12 md:col-4' },
            { name: 'sign_type', label: 'Sign Type', type: 'dropdown', options: SIGN_TYPES, default: 'DIGITAL', colClass: 'col-12 md:col-4' },
            { name: 'reason', label: 'Reason', icon: 'pi-info-circle', placeholder: 'Document signing', maxLength: 200, required: false },
            { name: 'callback_url', label: 'Callback URL', icon: 'pi-link', placeholder: 'https://your-app.com/callback', maxLength: 300, autoCapitalize: 'none', spellCheck: false },
        ]}
        endpoint={{
            path: '/surepass/esign/initialize-suresign',
            bodyMapper: (v, sid) => ({
                callback_url: v.callback_url.trim(),
                sign_type: v.sign_type,
                config: { auth_mode: v.auth_mode, reason: v.reason.trim() || 'Document signing' },
                prefill_options: { full_name: v.full_name.trim(), mobile_number: v.mobile_number, user_email: v.user_email.trim() },
                api_provider_service_id: parseInt(sid, 10),
            }),
        }}
        consentReportType="esign-initialize-suresign"
        submitLabel="Initialize Suresign"
        successSummary="Suresign initialized"
        errorSummary="Suresign initialization failed"
        confirmHeader="Confirm Suresign initialization"
        confirmAcceptLabel="Yes, initialize"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Suresign Session', icon: 'pi-pencil' }}
    />
);

export default EsignInitializeSuresignInputComponent;
